import React, { useEffect } from 'react'
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Loading2 from '../../../components/Loading2';
import GoogleAutocomplete from '../../taxiDriver/driveComponents/GoogleAutocomplete';
import { useLoadScript } from '@react-google-maps/api';
import Alert from 'react-bootstrap/Alert';
import './CreateNewOrder.css'
import CloseButton from 'react-bootstrap/CloseButton';
import uuid from 'react-native-uuid';
import Form from 'react-bootstrap/Form';

const api_key = process.env.REACT_APP_GOOGLE_KEY;
const places = ["places"]

const CreateNewOrder = ({listOfDrivers ,createOrderForDriver, setCreateOrderForDriver, server, token, whatTimeIsDriverReady}) => {

    const [loading , setLoading] = useState(false)
    const [start, setStart] = useState("")
    const [end, setEnd] = useState("")
    const [tel, setTel] = useState("")
    const [note, setNote] = useState("")
    const [sendForm, setSendForm] = useState(false)
    const [onTime, setOnTime] = useState(false)
    const [countOfExtraTrips , setCountOfExtraTrips] = useState(0)
    const [extraTrips, setExtraTrips] = useState([])
    const [dateTime, setDateTime] = useState(null)
    const [takeIt, setTakeIt] = useState(false)
    const [price, setPrice] = useState(null)
    const [distance, setDistance] = useState(null)
    const [arriveIn, setArriveIn] = useState(10)
    const [message, setMessage] = useState("")
    const [paymentMethod, setPaymentMethod] = useState(null);

    // Handler pro změnu hodnoty
    const handleSelectChange = (event) => {
        setPaymentMethod(event.target.value); // Nastaví hodnotu do stavu
    };


    const driverStatus = whatTimeIsDriverReady(Number(createOrderForDriver))

    useEffect( ()=> {
        if(driverStatus && driverStatus.timeLeft > arriveIn){
            setArriveIn(driverStatus.timeLeft)
        }
    }, [listOfDrivers])

    // Nastav pokud neni takeIt true, tak zobraz cenu, pak teprve vlož objednávku do systému

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: api_key,
        libraries: places,
    })

    const getDriver = (id) => {
        const result = listOfDrivers.find( one => Number(one.id) === Number(id) ) 
        console.log(result)
        return result
    }

    // Vložit ručně objednávku
    const saveHandleOrder = () => {
        if(start && end){
            console.log(createOrderForDriver)
            setLoading(true)
            fetch(server + "api2/centralaCreateOrder.php", {
                method: 'POST',
                body: JSON.stringify({
                adresStart: start.adres, 
                adresDest: end.adres,
                lat: start.gps.lat, 
                lng: start.gps.lng, 
                token: token, 
                desLat: end.gps.lat, 
                desLng: end.gps.lng, 
                takeIt: takeIt,
                howToPay: 0,
                tripDistance: 0,
                tel: tel,
                note: note,
                extraTrips: extraTrips,
                onTime: onTime,
                driverId: !onTime ? createOrderForDriver : null,
                bookTime: dateTime,
                arriveIn:arriveIn,
                price: price,
                message: message,
                howToPay: paymentMethod
                })
            })
            .then( (res)=>  res.json() )
            .then( (response) => {
                console.log(response)
                setLoading(false)
                // Závažná objednávka
                if(response.status === "OK" && takeIt){
                    window.location.reload();
                // Zatím kalkulace
                } else if(response.status === "OK" && !takeIt){
                    setPrice( Math.round( Number(response.price) ) )
                    setDistance( Math.round( Number(response.tripDistance) / 1000 ))
                } else if(response.status !== "OK") {
                    alert("Chyba systému")
                }
            })
        } else {
            alert("Vyplňte Start a Cíl")
        } 
    }



    const addExtraTrip = ( ) => {
        if(countOfExtraTrips < 3){
            setCountOfExtraTrips( countOfExtraTrips + 1)
            
        } else {
            alert('Je povoleno maximálně 3 mezizastávky')
        }  
    }

    const removeExtraTrip = () => {
        if(countOfExtraTrips > 0){
            setCountOfExtraTrips( countOfExtraTrips - 1)
            setExtraTrips( extraTrips.slice(0, -1))
        }
    }

    const handleExtraTrip = (even) => {
        setExtraTrips([...extraTrips ,{id: uuid.v4(), adres: even.adres , gps: {lat: even.gps.lat, lng: even.gps.lng} }])
    }

    useEffect( ()=> {
        if(start && end ){
            saveHandleOrder()
        } 

    }, [start, end, extraTrips, takeIt])


    const handleSubmit = () => {
        if(start && end && tel && paymentMethod){
            setTakeIt(true)
            saveHandleOrder()
        } else {
            alert('Je nutné vyplnit kde chce klient vyzvednout (start) a také Cíl, také klientovo telefon a způsob platby')
        }
    }


  return (

       <Modal show={createOrderForDriver} aria-labelledby="contained-modal-title-vcenter" size="lg" onHide={()=>setCreateOrderForDriver(null)} className='modalCreateOrder'>
       
            <Modal.Header closeButton  style={{background: '#eee'}}>
                <Modal.Title id="contained-modal-title-vcenter">
                Vytvoření objednávky
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="modalContentCreateOrder">
                <Row style={{padding: 16}}>
                    {/* Levá strana */}
                    <Col xs={12} md={6} style={{zIndex: 2000}}>
                        <div className='inputSection'>
                            <label htmlFor="">Jízda:</label>
                            <div style={{display: 'flex', gap: 16}} >
                                <div onClick={()=> setOnTime(false)} style={{ border: '1px solid grey', display: 'flex', paddingLeft: 16, paddingRight: 16, gap: 16, cursor: 'pointer', borderRadius: 10, ...(!onTime ? { backgroundColor: 'grey', color: 'white' } : { backgroundColor: '' }) }}>
                                    Okamžitá
                                </div>
                                <div onClick={()=> setOnTime(true)} style={{ border: '1px solid grey', display: 'flex', paddingLeft: 16, paddingRight: 16, gap: 16, cursor: 'pointer', borderRadius: 10, ...(onTime ? { backgroundColor: 'grey', color: 'white'  } : { backgroundColor: '' }) }}>
                                    Plánovaná
                                </div>
                            </div>
                            {onTime &&
                                <div>
                                    <label htmlFor="datetime">Vyberte datum a čas:</label>
                                    <input
                                        type="datetime-local"
                                        id="datetime"
                                        name="datetime"
                                        value={dateTime}
                                        onChange={(e) => setDateTime(e.target.value)}
                                        style={{
                                            padding: '10px',
                                            borderRadius: '5px',
                                            border: '1px solid #ccc',
                                            fontSize: '16px',
                                            width: '100%',
                                        }}
                                    />
                                </div>  
                            }
                        </div>
                        <div className='inputSection'>
                            <label htmlFor="">Start:</label>
                            <GoogleAutocomplete  outputFromGoogle={setStart} />
                        </div>
               
                        {[...Array(countOfExtraTrips)].map((_, index) => (
                            <div key={index} className='inputSection'>
                                <label htmlFor="">{index + 1}. mezizastávka:</label>
                                <div style={{gap: 16, display: 'flex', alignItems: 'center'}}>
                                    <GoogleAutocomplete outputFromGoogle={handleExtraTrip} />
                                    {index === countOfExtraTrips - 1 && (
                                        <CloseButton onClick={removeExtraTrip} />
                                    )}
                                </div>
                            </div>
                        ))}
                        <div style={{marginBottom: 24}} onClick={addExtraTrip}>
                            <Button variant="light">+ přidat mezizastávku </Button>
                        </div>

                        <div className='inputSection'>
                            <label htmlFor="">Cíl:</label>
                            <GoogleAutocomplete  outputFromGoogle={setEnd} />
                        </div>

                        <div className='inputSection'>
                            <label htmlFor="">Tel:</label>
                            <input type="text" placeholder='Telefon klienta' className='inputUserTel' value={tel} onChange={ (e)=> setTel(e.target.value)}/>
                            <p>Pokud nebude vyplněn klientovi se nepošle účtenka</p>
                        </div>

            
                    </Col>

                    {/* Pravá strana */}
                    <Col xs={12} md={6} style={{paddingLeft: 48}}>
                        <Alert variant="success" style={{background: '#eee'}}>
                            <Alert.Heading>Výpočet cesty</Alert.Heading>
                            <br></br>
                            <p>Řidič</p>
                            <h4>{onTime ? 'řidič není vybrán (jízda na čas), šichtu si veme ten kdo je ve službe' : getDriver(createOrderForDriver).nick}</h4>
                            <br></br>
                            <p>
                                {distance ? distance  + ' Km' : '' }
                            </p>
                            <hr />
                            <div className="mb-0">
                                {!onTime &&
                                    <div>
                                        <label htmlFor="">Řidič dorazí za (min):</label>
                                        <div style={{display: 'flex', alignItems: 'center', gap: 16}}>
                                            <input value={arriveIn} onChange={ (e) => setArriveIn(e.target.value)} className='inputUserTel' type='number' />
                                        </div>
                                    </div>
                                }
                
                            
                                <div style={{ alignItems: 'center', gap: 16, marginTop: 8}}>
                                
                                    <label htmlFor="">Cena:</label>
                                    <input value={price} onChange={ (e) => setPrice(e.target.value)} className='inputUserTel' type='number' />
                                    {(!start || !end) && 
                                    <p>Pro výpočet ceny zadejte start a cíl</p>
                                }
                                </div>

                                <div style={{ alignItems: 'center', gap: 16, marginTop: 24}}>
                                    <Form.Select 
                                        aria-label="Default select example" 
                                        value={paymentMethod} // Připojení stavu
                                        onChange={handleSelectChange} // Obsluha změny
                                    >
                                        <option>Způsob platby</option>
                                        <option value="1">Hotově</option>
                                        <option value="2">Kartou</option>
                                    </Form.Select>
                                </div>
                                
                                
                            </div>
                        </Alert>
                        <div className='inputSection'>
                            <label htmlFor="">Poznámka pro řidiče:</label>
                            <input type="text" placeholder='.. ' className='inputUserTel' value={message} onChange={ (e)=> setMessage(e.target.value)}/>
                        </div>
                    </Col>
                </Row>

        
                
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleSubmit}>Odeslat řidičovi</Button>
            </Modal.Footer>
            {loading && <Loading2 />}
        </Modal>
 
  )
}

export default CreateNewOrder
